import { createGlobalStyle } from 'styled-components'

export default createGlobalStyle`
	.react-tabs {
		.react-tabs__tab-list {
			border-bottom: 0;
			margin: 0 20px 1px 20px;
			user-select: none;

			.react-tabs__tab {
				font-size: 14px;
				color: #525252;
				padding: 4px 10px;
				background-color: #0003;
				border-top-left-radius: 8px;
				border-top-right-radius: 8px;
				margin-left: 4px;

				&:focus {
					box-shadow: none;
					border: 0;
				}

				&::after {
					height: 0;
				}

				&:not(.react-tabs__tab--selected) {
					opacity: 0.7;
				}
				
				&.react-tabs__tab--selected {
					font-weight: 700;
					border: 0;
					background-color: #f1f5f9;

					&:focus {
						border: 0;
					}

					&:hover {
						background-color: #f1f5f9;
					}
				}

				&:hover {
					background-color: #2223;
				}

				&.react-tabs__tab--disabled {
					color: #fff9;
				}
			}
		}

		.react-tabs__tab-panel {
			background-color: #f1f5f9;
			border-radius: 16px;
			padding: 16px 24px;
			box-shadow: 0 2px 2px 0 rgba(0,0,0,0.14),0 3px 1px -2px rgba(0,0,0,0.12),0 1px 5px 0 rgba(0,0,0,0.2);
		}
	}

	.tabs-landing-page {
		color: #424242;

		.react-tabs__tab-list {
			background-color: #eee;
			border: 0;
			border-radius: 8px;
			width: fit-content;
			margin: 0 auto 1.2rem;
			user-select: none;
			transition: all;
			transition-duration: 500ms;

			.react-tabs__tab {
				bottom: 0;
				padding: 8px 12px;
				
				&:focus {
					box-shadow: unset;
				}

				.subtext {
					color: #888;
				}

				&.react-tabs__tab--selected {
					border: 0;
					background-color: #059669;
					border-radius: 8px;
					font-weight: 800;
					color: #fff;
					
					.subtext {
						color: #d8f999;
					}
				}
			}
		}
	}
`
